import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";



// components
import ActivityForm from "./_form";
import ActivityFilters from "./_filters";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {LB_ACTIONS, LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {hotelActivityService} from "../../../jwt/_services/hotel/hotelActivityService";

// utils
import {getStateByPath} from "../../../redux/selectors";



const HotelActivityList = (props) => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {udn, userIsAdmin, app, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    const {fbDataBase} = app

    useEffect( () => {
        if(filter || !app?.id)
            return

        props.setFilter(path, {
            fbDataBase,
            onlyRegistered:true,
            item: {
                code: null,
                udn: { id: udn?.id },
            }
        })
    }, [app]);


    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, hotelActivityService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);


    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(ActivityForm, { path, data })
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(ActivityForm, { path })
    }


    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: fbDataBase?.id,
        service: hotelActivityService,
        remove : genericIndexedActions.delete,
    } );

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            headerStyle: {width: '0px'},
            hidden: true
        }, {
            dataField: 'uid',
            text: 'Firebase Id',
            headerStyle: {width: '200px'},
            hidden: !userIsAdmin
        }, {
            dataField: 'code',
            text: 'Código',
            hidden: !userIsAdmin
        }, {
            dataField: 'title',
            text: 'Titulo'
        }, {
            dataField: 'duration',
            text: 'Horario',
            headerAlign: 'center',
            align: 'center',
            hidden: userIsAdmin
        }, {
            dataField: 'status',
            text: "Activo",
            headerStyle: {width: '30px'},
            headerAlign: 'center',
            align: 'center',
            formatter: (cell) => <ActiveFormatter active={cell}/>
        },{
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '195px'},
            formatter: (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <TranslateButton item={row} service={hotelActivityService} path={path}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>
        }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <ActivityFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(HotelActivityList);